import { makeStyles } from "@material-ui/core";

const useTableStyles = makeStyles({
  table: {
    borderCollapse: "separate",
    borderSpacing: "0.8rem 0.2rem",
    marginTop: 16,
    fontSize: 13,
    "& tbody > tr > td": {
      fontWeight: 600,
      paddingBottom: 8,
      verticalAlign: "text-top",
    },
    "& tbody > tr > td:last-child": {
      wordBreak: "break-word",
    },
    "& tbody > tr > td:first-child": {
      width: 120,
      wordBreak: "normal",
    },
  },
});

export default useTableStyles;
